<template>
  <section class="validate-professionals">
    <div class="validate-professionals-itens">
      <Breadcrumb :links="links" />
      <div class="validate-professionals-btns">
        <button
          class="validate-professionals-btns__element"
          :class="{
            'validate-professionals-btns__element--active': isProfileValid,
          }"
          @click="handleClickBtnsProfiles('valid')"
        >
          Perfis válidos
          <span class="">({{ countProfileValid }})</span>
        </button>
        <button
          class="validate-professionals-btns__element"
          :class="{
            'validate-professionals-btns__element--active': isProfileInvalid,
          }"
          @click="handleClickBtnsProfiles('invalid')"
        >
          Perfis inválidos
          <span>({{ countProfileInvalid }})</span>
        </button>
      </div>
      <div class="validate-professionals-itens-body">
        <div class="row validate-professionals__row">
          <div
            class="col-12 col-lg-6 col-xl-4"
            v-for="professional in filteredAllProfessionals"
            :key="professional.data.id"
          >
            <CardValidateProfessional :professional="professional" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardValidateProfessional from "@/views/Professional/components/CardValidateProfessional";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Validar perfis de profissionais",
          routerName: "ValidateProfessionals",
        },
      ],
      isProfileValid: true,
      isProfileInvalid: false,
    };
  },
  components: {
    Breadcrumb,
    CardValidateProfessional,
  },
  computed: {
    ...mapGetters("Professional", ["allProfessionals"]),
    filteredAllProfessionals() {
      if (this.isProfileValid) {
        return this.allProfessionals.filter(
          (item) => item.data.profile_is_valid === true
        );
      }

      if (this.isProfileInvalid) {
        return this.allProfessionals.filter(
          (item) => item.data.profile_is_valid === false
        );
      }

      return this.allProfessionals;
    },
    countProfileValid() {
      const profileValid = this.allProfessionals.filter(
        (item) => item.data.profile_is_valid === true
      );
      return profileValid.length;
    },
    countProfileInvalid() {
      const profileInvalid = this.allProfessionals.filter(
        (item) => item.data.profile_is_valid === false
      );
      return profileInvalid.length;
    },
  },
  async mounted() {
    await this.consultProfessionalPendingValidate();
  },
  methods: {
    ...mapActions("Professional", ["consultProfessionalPendingValidate"]),
    handleClickBtnsProfiles(value) {
      if (value === "valid") {
        this.isProfileInvalid = false;
        this.isProfileValid = true;
        return;
      }

      this.isProfileValid = false;
      this.isProfileInvalid = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.validate-professionals {
  padding-bottom: 50px;
  &__row {
    row-gap: 30px;
  }
  &-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-bottom: 50px;
    @media (max-width: 991px) {
      gap: 15px;
      margin-bottom: 30px;
    }
    &__element {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      background: 0;
      border: 0;
      border-bottom: 2px solid transparent;
      font-size: 20px;
      font-family: "Font Light";
      color: var(--black);
      @media (max-width: 991px) {
        font-size: 14px;
      }
      &--active {
        font-family: "Font Semibold";
        font-size: 24px;
        border-color: var(--green);
        @media (max-width: 991px) {
          font-size: 16px;
        }
      }
      span {
        margin-left: 5px;
      }
    }
  }
}
</style>
